export type HeroVariant = 'statement' | 'split' | 'kinetic';

export const siteConfig = {
  /** Which hero treatment the homepage leads with. */
  heroVariant: 'split' as HeroVariant,
  /** Overrides the accent colour throughout. Design palette: #0056b3, #1f6bff, #0a2a6b, #00d1b2. */
  accent: '#1f6bff',
  /** Forces motion off regardless of the visitor's `prefers-reduced-motion` setting. */
  reduceMotion: false,
  email: 'sales@proteus.tech',
  location: 'London, United Kingdom',
  companyName: 'Proteus Technologies Ltd',
  companyNumber: '09979806'
};
